const Enum = {
	AVAILABLE_BOOKING: {
		CRADLE_TYPE_ID: 1, // SELF_RESEARCHER
		DARE_TYPE_ID: 2,
		EXPERT_TYPE_ID: 3, // COL_RESEARCHER
	},
	EXPERT_TYPE: {
		STANDARD: 1,
		CUSTOM: 2,
	},
	PROJECT_TYPE: {
		1: "CRADLE",
		2: "DARE",
		3: "EXPERT",
	},
	WEEKS: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	ERROR_CODE: {
		TOKEN_INVALID: 430,
		NO_AUTHORITY: 401,
		NEED_TO_CHANGE_PASSWORD: 431,
		SHOW_DETAIL_ERROR: 510,
	},
};

export default Enum;
